import { ResizeObserverContainer } from 'components/ResizeObserverContainer/ResizeObserverContainer';
import { getPieVendorChart } from 'containers/Chartjs';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { equals } from 'ramda';
import { Component } from 'react';

export default class NetworkVendorMix extends Component {
  static propTypes = {
    Chart: PropTypes.any.isRequired,
    data: PropTypes.shape({
      networkVendorMix: PropTypes.object,
    }).isRequired,
    msg: PropTypes.object.isRequired,
  };

  state = {
    width: null,
  };

  componentDidMount() {
    this.drawGraph();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !equals(
        nextProps.data.networkVendorMix,
        this.props.data.networkVendorMix,
      ) || this.state.width !== nextState.width
    );
  }

  getSnapshotBeforeUpdate(_prevProps, prevState) {
    if (this.state.width !== prevState.width && this.pieVendorChart) {
      this.pieVendorChart.destroy();
      return true;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !equals(
        prevProps.data.networkVendorMix,
        this.props.data.networkVendorMix,
      ) &&
      this.pieVendorChart
    ) {
      this.pieVendorChart.destroy();
    }
    if (this.state.width !== prevState.width) {
      this.drawGraph(false);
    } else {
      this.drawGraph();
    }
  }

  componentWillUnmount() {
    if (this.pieVendorChart) {
      this.pieVendorChart.destroy();
    }
  }

  drawGraph = (animationEnabled = true) => {
    const {
      msg,
      Chart,
      data: { networkVendorMix },
    } = this.props;
    if (this.networkVendorMix) {
      this.pieVendorChart = getPieVendorChart(
        Chart,
        this.networkVendorMix,
        msg.networkVendorMix,
        animationEnabled,
        networkVendorMix.labels,
        networkVendorMix.data,
      );
    }
  };

  handleResize = (element) => {
    const PADDING = 30;

    this.setState({
      width: element.clientWidth - PADDING,
    });
  };

  render() {
    const {
      msg,
      data: { networkVendorMix },
    } = this.props;
    const data = get(networkVendorMix, 'data');
    const width = this.state.width <= 400 ? this.state.width : '400';

    if (!data || !data.length) {
      return (
        <div>
          <h4 className='dashboard-vendor-mix__title'>
            {get(msg, 'networkVendorMix')}
          </h4>
          <p>{get(msg, 'noDataAvailable')}</p>
        </div>
      );
    }

    return (
      <div className='row'>
        <ResizeObserverContainer
          className='col-xs-12'
          onResize={this.handleResize}
        >
          <canvas
            className='center-block'
            height='400'
            ref={(c) => {
              this.networkVendorMix = c;
            }}
            width={width}
          />
        </ResizeObserverContainer>
      </div>
    );
  }
}
